import React from 'react';

import './publicPages.css';

const Footer = () => (
  <footer className='br-public-footer'>
    <div className='br-public-footer__content'>
      <div>
        <img
          className='br-public-footer__logo'
          src='/assets/images/BR-orange-horizontal-small.png'
          alt='BetaReader'
        />
      </div>
      <nav aria-label='Legal information' className='br-public-footer__links'>
        <a href='https://betareader.io/terms-of-service' target='_br_tos'>Terms of Service</a>
        <a href='https://betareader.io/privacy-policy' target='_br_privacy'>Privacy Policy</a>
      </nav>
      <nav aria-label='Support' className='br-public-footer__links'>
        <a href='https://betareader.io/help' target='_br_help_center'>Help center</a>
        <a href='mailto:support@betareader.io'>Email Us</a>
      </nav>
      <span>&copy; BetaReader Sweden AB 2017-2023</span>
    </div>
  </footer>
);

export default Footer;
